exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FITBAnswerBox .answerOp{display:inline-block;white-space:nowrap;border:1px solid #ccc;border-radius:3px;padding:0 10px;margin-right:5px;margin-bottom:5px}.FITBAnswerBox .answerOp:hover{text-decoration:line-through;cursor:pointer;opacity:.7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/questions/fitb_answer_box.scss
// module id = 1521
// module chunks = 0